import { CountryCode, parsePhoneNumber } from 'libphonenumber-js'

export const formatPhoneNumberE164 = (phoneNumber: string, countryCode: CountryCode) => {
  const parsedPhoneNumber = parsePhoneNumber(phoneNumber, countryCode)

  return parsedPhoneNumber.number
}
